import { useQueries } from "@tanstack/react-query";
import { api } from "../api";

interface DayMetricsParams {
  date: string;
  isSTLY?: boolean;
}

/**
 * Fetches day-metrics for multiple dates in parallel.
 *
 * This hook wraps TanStack Query's useQueries to:
 * 1. Automatically retry when userId becomes available (unlike manual useEffect)
 * 2. Leverage caching and deduplication across components
 * 3. Provide consistent loading/error states
 *
 * Use case: Group quotes need metrics for all nights in the stay period.
 */
export function useDayMetricsForDates(
  userId: string | undefined,
  dates: DayMetricsParams[]
) {
  return useQueries({
    queries: dates.map(({ date, isSTLY }) => ({
      queryKey: ["dayMetrics", userId, date, isSTLY ? "stly" : "current"],
      queryFn: () =>
        api.getDayMetrics(userId!, {
          type: "Summary",
          date,
          ...(isSTLY && { isSTLY: true }),
        }),
      enabled: !!userId && dates.length > 0,
      staleTime: 5 * 60 * 1000, // 5 minutes - same as calendar
    })),
  });
}
